import { Box, BoxProps } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';

interface WrapperProps extends BoxProps {
  children: React.ReactNode;
  isReadOnly?: boolean;
}

export const Wrapper = ({
  children,
  isReadOnly = false,
  ...props
}: WrapperProps) => {
  //note: reportID comes for only custom reports
  const { reportID } = useParams();

  return (
    <Box
      border={!reportID && !isReadOnly && '1px solid #EAECF0'}
      bg="#fff"
      p={!reportID && !isReadOnly && '24px'}
      borderRadius="12px"
      className="wide-content chart-container"
      data-test-id="section-pipeline-funnel"
      h="calc(100% - 35px)"
      {...props}
    >
      {children}
    </Box>
  );
};
